module.exports = __webpack_public_path__ + "img/烟花.a9ddf719.png";